import Api from "./index";
import { endPoints, requestType } from "../constants/Variables";

// export const createCategory = (params) => {
//   return Api(endPoints.createCategory, params, requestType.POST);
// };
export const handleUpdateCategory = (id, params) => {
  return Api(`${endPoints.updateCategory}/${id}`, params, requestType.PUT);
};

export const getBranchCategory = (selectedBranch, businessId) => {
  return Api(endPoints.getBranchCategory, null, requestType.GET);
};

export const handleGetCategory = (selectedBranch, businessId) => {
  return Api(
    `${endPoints.fetchCategory}?branchId=${selectedBranch}&businessId=${businessId}`,
    null,
    requestType.GET
  );
};

export const handleDeleteCategory = (id) => {
  return Api(`${endPoints.deleteCategory}/${id}`, null, requestType.GET);
};

//>>>>>>>>>>>>>>>>>>>>>>>>>New Flow Work<<<<<<<<<<<<<<<<<<<<//
export const createCategory = (params) => {
  return Api(endPoints.createCategory, params, requestType.POST);
};
